// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"248":"20c7831f","669":"20c7831f","784":"20c7831f"}[chunkId] + ".chunk.css";
};